import React from 'react';

import bus from '../../assets/images/loading/bus-blue.svg';

import './loading.component.scss';

const Loading = () => (
	<div id="loading-page">
		<div className="loader">
			<div className="bus">
				<img src={bus} alt="" />
			</div>
			<div className="wave">
				<div className="wave-container">
					<div className="sliding-background" />
				</div>
			</div>
		</div>
	</div>
);

export default Loading;
